<div class="activation-container">
  <div class="activation-card">
    <!-- TiPay Logo -->
    <div class="logo-container">
      <img src="assets/logo_tipay.svg" alt="TiPay Logo" class="logo">
    </div>

    <!-- Loading State -->
    <div *ngIf="activationStatus === 'loading'" class="loading-state">
      <div class="spinner"></div>
      <h2>Activation de votre compte en cours...</h2>
      <p>Veuillez patienter pendant que nous vérifions vos informations.</p>
    </div>

    <!-- Success State -->
    <div *ngIf="activationStatus === 'success'" class="success-state">
      <div class="status-icon success">
        <i class="pi pi-check-circle"></i>
      </div>
      <h2>Félicitations!</h2>
      <p>Votre compte a été activé avec succès.</p>
      <p>Vous pouvez maintenant vous connecter à votre compte TiPay.</p>
      <button class="tipay-button" (click)="navigateToLogin()">
        Se connecter
      </button>
    </div>

    <!-- Error State -->
    <div *ngIf="activationStatus === 'error'" class="error-state">
      <div class="status-icon error">
        <i class="pi pi-times-circle"></i>
      </div>
      <h2>Échec de l'activation</h2>
      <p>{{ errorMessage }}</p>
      <p>Si vous rencontrez des problèmes, veuillez contacter notre support.</p>
      <button class="tipay-button" (click)="navigateToLogin()">
        Retour à la page de connexion
      </button>
    </div>
  </div>
</div>

<p-toast position="top-right"></p-toast>
